module.exports = __webpack_public_path__ + "img/zeev-smc.0f0ac57e.jpg";